import { render } from "./testPincode.vue?vue&type=template&id=378307b5"
import script from "./testPincode.vue?vue&type=script&lang=js"
export * from "./testPincode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__